import { BoxProps, Box } from "@mui/system";
import React, { forwardRef } from "react";

interface CustomButtonProps extends BoxProps {
    onClick: () => void;
    children: React.ReactNode;
}

export const UserDefinedButton: React.FC<CustomButtonProps> = forwardRef(function CustomButton(props, ref) {
    const { onClick, children, ...otherProps } = props;

    return (
        <Box
            onClick={onClick}
            role="button"
            tabIndex={0}
            ref={ref}
            {...otherProps}
            sx={{
                display: "inline-block",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: "pointer",
                textAlign: "center",
                transition: "background-color 0.3s",
            }}
        >
            {children}
        </Box>
    );
});
